export default __webpack_public_path__ + "static/media/MobileStep1.77b733e2.svg";